/*
    * Handler functions that perform modifications of data in the state tree
*/
import Vue from "vue";
import { MutationTree } from "vuex";
import { App } from "./types";
import * as _ from 'lodash';
import router from '@/router';
import { AppConstants as _app } from '@/shared/app.constants';
import AuthService from '@/services/auth.service';

const auth = new AuthService();

/*
    * Computed properties
*/
export const mutations: MutationTree<App> = {
    /*
        * v-app-bar button action event
    */
    _appBtnClick(state, button) {
        //#.Menu search
        switch (button) {
            case "search":
                if (state.search.container) {
                    state.search.container = false;
                } else {
                    state.search.container = true;
                }
                break;
            case "profile":
                //#.Remove component in the DOM
                state.profile = false;

                Vue.nextTick(function () {
                    //#. Add the component back in
                    state.profile = true;
                });
                break;
            case "announce":
            ////#.Remove component in the DOM
            //state.announcement = false;
            //state.profileClose = false;
            //state.moduleGroup.container = false;
            //// @ts-ignore
            //this.state.dashboard.renderComponent = false;

            ////#.Update url
            //history.pushState({
            //    id: ''
            //}, '', location.origin);

            ////#.Reset location storage information and root props
            //state.height = '0px !important';
            //localStorage.setItem('vueAppMenuTab', '');
            //localStorage.setItem('breadcrumbs', '');
            //state.breadcrumbs.list = [];
            //state.menu.tabs = [];

            //Vue.nextTick(function () {
            //    //#. Add the component back in
            //    state.announcement = true;
            //});
            //break;
            default:
                break;
        }
    },

    /*
        * v-app-bar button action event
    */
    _appTabClick(state, moduleName) {
        //#.Checking of menu permission
        if (state.menu.collection.length > 0) {
            state.menu.tree = [];

            state.menu.collection.filter(x => x.Module == moduleName).forEach(key => {
                state.menu.tree.push(key);
            });
        }
    },

    /*
        * v-app-bar triggered tile click event
    */
    _appTileClick(state, payload) {
        if (payload.id == 10) {
            state.menu.tabs = [];
            state.moduleGroup.name = payload.title;
            state.moduleGroup.icon = payload.icon;
            state.moduleGroup.color = payload.color;

            localStorage.setItem('vueAppMenuTab', JSON.stringify(state.menu.tabs));
            localStorage.setItem('vueAppModule', JSON.stringify(state.moduleGroup));
            localStorage.setItem('breadcrumbs', '');
            location.href = '/dashboard';
            return;
        }

        //#.Checking of module binding
        if (payload.Modules.length == 0)
            return;

        state.height = '38px !important';

        state.menu.tabs = [];
        state.moduleGroup.name = payload.title;
        state.moduleGroup.icon = payload.icon;
        state.moduleGroup.color = payload.color;

        //#.Checking of module binding
        if (payload.Modules.length > 0) {
            payload.Modules.filter(x => x.ModuleName != null).forEach(key => {
                if (state.menu.collection.filter(x => x.Module == key.ModuleName).length > 0)
                    state.menu.tabs.push(key.ModuleName);
            });

            localStorage.setItem('vueAppMenuTab', JSON.stringify(state.menu.tabs));
            localStorage.setItem('vueAppModule', JSON.stringify(state.moduleGroup));
        }

        //#. Remove the tile component in DOM
        state.moduleGroup.container = false;
        state.announcement = false;

        if (payload.id == 1) {
            auth.isLoggedIn().then((isLoggedIn: boolean) => {
                if (isLoggedIn) {
                    auth.getUser().then((user) => {
                        let allowedRoles = ['1', '2', '3', '13', '15', '19'];
                        let userRoles = [];
                        if (Array.isArray(user.profile.role_id)) {
                            userRoles = userRoles.concat(user.profile.role_id);
                        } else {
                            userRoles.push(user.profile.role_id);
                        }

                        if (allowedRoles.filter(i => userRoles.indexOf(i) >= 0).length > 0) {
                            if (userRoles.filter(i => i == _app.appRoles.MEAdmin).length > 0)
                                location.href = '/Admin/Program/MEIndicator?mId=63';
                            else if (userRoles.filter(i => i == _app.appRoles.CommunicationOfficer).length > 0)
                                location.href = '/Admin/Communication/Template%20Mapping/CallCommunicationTemplate?mId=104';
                            else
                                location.href = '/Admin/Program/Initiative?mId=34';
                        } else {
                            router.push("/dashboard");
                        }
                    });
                }
            });
        }
    },

    /*
        * Get the module group based on the permission
    */
    _getModuleGroup(state, payload) {
        auth.isLoggedIn().then((isLoggedIn) => {
            state.authorized = isLoggedIn;
            //state.applicationName = "IUCN Grants Portal - Application";

            auth.getUser().then((user) => {
                state.loggedInUser = user.profile.given_name;
                state.userId = parseInt(user.profile.sub);
            });
        });

        //#.Set current location
        state.avatar = payload.avatar;
        state.accountingLocation = payload.location;
        state.moduleGroup.list = payload.moduleGroups;
        state.moduleGroup.modules = payload.modules;

        if (payload.menuList.length > 0) {
            payload.menuList.filter(x => x.id != null).forEach(key => {
                state.menu.collection.push(key);
            });

            //#.Bind frequent menu list
            state.menu.collection.filter(function f(o) {
                if (o.children.length == 0) {
                    o.feqName = o.name + ' (' + o.Module + ')';
                    state.search.menus.push(o);
                }

                if (o.children.length != 0) {
                    return o.children.filter(f);
                }
            })
        }

        payload.moduleGroups.filter(x => x.Id != null).forEach(key => {
            //#.Checking module permission
            if (key.Modules.length == 0)
                key.isDisabled = true;
            else
                key.isDisabled = false;

            let id = key.Id, module = key.Modules, disable = key.isDisabled, self = this;
            state.moduleGroup.tiles.filter(x => x.items != null).forEach(val => {
                //#.Module group show order
                val.items = _.orderBy(val.items, ['showOrder'], ['asc']);

                val.items.filter(x => x.id != null).forEach(record => {
                    if (record.id == id) {
                        record['Modules'] = module;
                        record['isDisabled'] = disable;
                    }
                });
            });
        });
    },

    /*
        * Application About details
    */
    _appAbout(state, message) {
        //#.Remove component in the DOM
        state.about.enabled = false;

        Vue.nextTick(function () {
            //#. Add the component back in
            state.about.enabled = true;
        });
    },

    /*
        * Vuex error log 
    */
    _appErrorLog(state, message) {
        console.log(message.error);
    }
};
